import { history, RoutePaths } from 'core/history';
import React from 'react';
import { Button, ButtonType, Typography } from 'syngenta-digital-cropwise-react-ui-kit';
import './style.less';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { AppConstants } from 'core/app.constants';
const {
  Text
} = Typography;
interface IAppsPageHeader {
  currentUserCanCreateApps: boolean;
  setSearch: (search: string) => void;
}
export const AppsPageHeader: React.FC<IAppsPageHeader> = (props: IAppsPageHeader) => {
  return <>
      <Text strong={true} style={{
      fontSize: '20px',
      color: '#2F3031',
      marginBottom: '5px'
    }} data-sentry-element="Text" data-sentry-source-file="index.tsx">
        Apps
      </Text>
      <div className="cw-app-create-app-button">
        <Input prefix={<SearchOutlined />} data-testid="apps-page-header-search-input" placeholder="Search apps" autoFocus={true} style={{
        width: '270px'
      }} onChange={e => props.setSearch(e.target.value)} maxLength={AppConstants.NAME_MAX_LENGTH} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        <Button type={ButtonType.success} data-testid="create-app-button" onClick={() => {
        history.push(RoutePaths.CREATE_APP());
      }} style={{
        borderColor: '#c1c5c8'
      }} disabled={!props.currentUserCanCreateApps} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          Create App
        </Button>
      </div>
    </>;
};